import { BasicModal } from 'components/UI/BasicModal';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import React from 'react';
import { getText } from 'services/languageService';
import { logOutAction, setOpenLogoutAction } from 'store/actions/mainPage';

export const LogOutModal: React.FC = () => {
  const { isOpenLogout } = useAppSelector((state) => state.mainPage);
  const dispatch = useAppDispatch();

  const closeLogout = () => {
    dispatch(setOpenLogoutAction(false));
  };

  const logOut = () => {
    dispatch(logOutAction());
  };

  return (
    <BasicModal
      isOpen={isOpenLogout}
      firstButtonText={getText('YES')}
      secondButtonText={getText('NO')}
      modalText={getText('LOG_OUT_CONFIRM')}
      onFirstButtonClick={logOut}
      onSecondButtonClick={closeLogout}
      handleClose={closeLogout}
      centeredText
    />
  );
};
